import { render, staticRenderFns } from "./ScheduleTypeSelector.vue?vue&type=template&id=5890fca6"
import script from "./ScheduleTypeSelector.vue?vue&type=script&lang=js"
export * from "./ScheduleTypeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports